// Copyright (c) 2026 Optimum Healthcare IT. All rights reserved.
// Author: Frank Scalzo <Optimum Healthcare IT>
// License: proprietary
// provenance-id: b5f2db04-113f-41a5-a75a-13dd292b593e

import React from 'react';

// Primordia product mark — a DNA double helix. "Where enterprise systems begin":
// the application genome / origin. Optimum brand palette (navy → blue).
// `spinning` rotates the helix about its own vertical axis. A plain 2D spin
// looks like a wheel; rotateY makes the strands cross over each other, which is
// what makes it read as DNA unwinding.
export default function PrimordiaLogo({ size = 34, spinning = false }) {
  const h = size;
  const w = size * 0.64;
  return (
    <svg width={w} height={h} viewBox="0 0 26 42" fill="none" xmlns="http://www.w3.org/2000/svg"
      role="img" aria-label={spinning ? 'Loading' : 'Primordia'}
      style={spinning ? { animation: 'primordiaHelix 1.6s linear infinite', transformOrigin: '50% 50%' } : undefined}>
      {spinning && (
        <style>{`@keyframes primordiaHelix {
          from { transform: rotateY(0deg); }
          to   { transform: rotateY(360deg); }
        }`}</style>
      )}
      <defs>
        <linearGradient id="primStrandA" x1="0" y1="0" x2="26" y2="42" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3D9AD1" />
          <stop offset="1" stopColor="#0D5B9A" />
        </linearGradient>
        <linearGradient id="primStrandB" x1="26" y1="0" x2="0" y2="42" gradientUnits="userSpaceOnUse">
          <stop stopColor="#021F4B" />
          <stop offset="1" stopColor="#0D5B9A" />
        </linearGradient>
      </defs>
      {/* base-pair rungs (behind strands) */}
      <g stroke="#9EC4E4" strokeWidth="1.7" strokeLinecap="round">
        <line x1="8.5" y1="6" x2="17.5" y2="6" />
        <line x1="6.5" y1="11" x2="19.5" y2="11" />
        <line x1="6.5" y1="31" x2="19.5" y2="31" />
        <line x1="8.5" y1="36" x2="17.5" y2="36" />
      </g>
      {/* two helical strands */}
      <path d="M5 1.5 C 25 8, 25 14, 13 21 C 1 28, 1 34, 21 40.5" stroke="url(#primStrandA)" strokeWidth="2.7" strokeLinecap="round" />
      <path d="M21 1.5 C 1 8, 1 14, 13 21 C 25 28, 25 34, 5 40.5" stroke="url(#primStrandB)" strokeWidth="2.7" strokeLinecap="round" />
    </svg>
  );
}
